import dayjs from 'dayjs'
import CantileverTheme from 'styles/cantileverTheme'

export const ASSET_COLORS = [
  CantileverTheme.colors.OceanBlue,
  CantileverTheme.colors.Teal,
  CantileverTheme.colors.Turquoise,
  CantileverTheme.colors.warning['500'],
  CantileverTheme.colors.average['400'],
  CantileverTheme.colors.average['600'],
  CantileverTheme.colors.success['450'],
  CantileverTheme.colors.grayscale['500'],
  CantileverTheme.colors.gold['600'],
  CantileverTheme.colors.green['600'],
  CantileverTheme.colors.crimson['600'],
  CantileverTheme.colors.purple['400'],
]

export const getColorForAsset = (assetId: string): string => {
  // Use DJB2
  let hash = 5381
  for (let i = 0; i < assetId.length; i++) {
    hash = (hash << 5) + hash + assetId.charCodeAt(i)
  }
  return ASSET_COLORS[Math.abs(hash) % ASSET_COLORS.length]
}

export const isRecentInspection = (date: string | undefined) => {
  if (!date) return false
  const inspectionDate = dayjs(date)
  if (!inspectionDate.isValid()) return false
  const now = dayjs()
  const twoWeeksAgo = now.subtract(2, 'weeks')
  return inspectionDate.isAfter(twoWeeksAgo) && inspectionDate.isBefore(now)
}
